import ProductsBlock from '@containers/products-block';
import { useMainProductsQuery } from '@framework/product/get-all-main-products';
import React from 'react';
interface PopulerProductFeedProps {
  limit?: number;
}
export default function PopulerProductFeed({
  limit = 12
}: PopulerProductFeedProps) {
  const {
    data,
    isLoading,
    error,
    status
  } = useMainProductsQuery({
    limit
  });
  let headerText;
  if (status === 'success' && data?.length > 0) {
    headerText = data[0].headerCategory;
  }
  if (data?.length === 0) {
    return <></>;
  }
  return <ProductsBlock sectionHeading={headerText ? 'text-main-' + headerText : 'text-loading'} products={data} loading={isLoading} error={error?.message} uniqueKey='best-sellers' data-sentry-element="ProductsBlock" data-sentry-component="PopulerProductFeed" data-sentry-source-file="popular-product.tsx" />;
}